import { URI } from '@/config/config';

export default async ({ rootState }, { permissions, name, roleId }) => {
  const opts = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
    body: JSON.stringify({ permissions, name }),
  };

  const requestList = await fetch(`${URI}control-panel/roles/${roleId}`, opts);
  const jsonResult = await requestList.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult.list;
};
